/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from "react-router-dom"
import { IRepresentanteSd41 } from "../../../Dtos/Cadastros/Representantes/RepresentantesDtos"
import { useEffect, useState } from "react"
import ApiService from "../../../Config/ApiConfig"
import LoadingPage from "../../../Components/Loading/Loading"
import AppLayout from "../../../Components/Layout/Layout"
import PageTitle from "../../../Components/PageTitle/PageTitle"
import { FormContainer } from "../../../Components/Forms/FormContainer/FormContainer"
import { FormGrid } from "../../../Components/Forms/FormGrid/FormGrid"
import { FormField } from "../../../Components/Forms/FormField/FormField"
import { Label } from "../../../Components/Forms/Label/Label"
import { Input } from "../../../Components/Forms/Input/Input"
import { ButtonContainer } from "../../../Components/Forms/ButtonContainer/ButtonContainer"
import { ButtonSecundary } from "../../../Components/Forms/CancelButton/CancelButton"
import { ButtonPrimary } from "../../../Components/Forms/SaveButton/SaveButton"
import { InputData } from "../../../Components/Forms/InputData/InputData"

export const FormRepresentantePage = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState<boolean>(false)
    const [formData, setFormData] = useState<IRepresentanteSd41>({
        sd41codigo: "",
        sd41nome: "",
        sd41cnpj: "",
        sd41ddd1: "",
        sd41fone1: "",
        sd41ddd2: "",
        sd41fone2: "",
        sd41ddd3: "",
        sd41fone3: "",
        sd41cep: "",
        sd41endereco: "",
        sd41numero: null,
        sd41complemento: "",
        sd41bairro: "",
        sd41municipio: "",
        sd41uf: "",
        sd41email: "",
        sd41dtinicio: "",
        sd41du: "",
        sd41na: "",
        sd41dirformulas: "",
        sd41senha: "",
    });

    useEffect(() => {
        async function checkApi() {
            try {
                const apiService = new ApiService();

                const response = await apiService.get<boolean>("/auth/temAcesso", { params: { tarefa: "Representantes" } })

                if (!response) {
                    navigate("/home");
                }
            } catch (error) {
                navigate("/home");
            }
        }

        checkApi();
    }, []);

    useEffect(() => {
        if (id != null) buscarRepresentantePeloId()
    }, [])

    const buscarRepresentantePeloId = async () => {
        try {
            setLoading(true)
            const apiService = new ApiService()

            const sd41 = await apiService.get<IRepresentanteSd41>("/sd41Controller/buscarRepresentantePeloId", {
                params: {
                    'sd41id': id
                }
            })

            setFormData(sd41)
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleChangeDataInicio = (value: string) => {
        setFormData(prev => ({
            ...prev,
            sd41dtinicio: value
        }));
    }

    const handleSubmit = async (e: React.FormEvent) => {
        try {
            e.preventDefault();
            setLoading(true)

            //const apiServer = new ApiService()
            //await apiServer.post('/sd41Controller/salvarRepresentante', formData)
            //navigate("/representantes")
        } catch (error) {
        } finally {
            setLoading(false)
        }
    };

    const handleCancelar = () => {
        if (id != null) {
            buscarRepresentantePeloId()
            return
        }
        setFormData({
            sd41codigo: "",
            sd41nome: "",
            sd41cnpj: "",
            sd41ddd1: "",
            sd41fone1: "",
            sd41ddd2: "",
            sd41fone2: "",
            sd41ddd3: "",
            sd41fone3: "",
            sd41cep: "",
            sd41endereco: "",
            sd41numero: null,
            sd41complemento: "",
            sd41bairro: "",
            sd41municipio: "",
            sd41uf: "",
            sd41email: "",
            sd41dtinicio: "",
            sd41du: "",
            sd41na: "",
            sd41dirformulas: "",
            sd41senha: "",
        })
    }

    if (loading) {
        return (
            <LoadingPage />
        )
    }

    return (
        <AppLayout>
            <PageTitle title='Representante' />
            <FormContainer>
                <form onSubmit={handleSubmit}>
                    <FormGrid>
                        <FormField myWidth={10}>
                            <Label>Código</Label>
                            <Input
                                type="text"
                                name="sd41codigo"
                                value={formData.sd41codigo}
                                onChange={handleChange}
                                required
                                validation="numbers"
                                maxCharacters={2}
                            />
                        </FormField>
                        <FormField>
                            <Label>Nome</Label>
                            <Input
                                type="text"
                                name="sd41nome"
                                value={formData.sd41nome}
                                onChange={handleChange}
                                required
                            />
                        </FormField>
                        <FormField myWidth={40}>
                            <Label>Nome Abreviado</Label>
                            <Input
                                type="text"
                                name="sd41na"
                                value={formData.sd41na}
                                onChange={handleChange}
                                required
                            />
                        </FormField>
                    </FormGrid>
                    <FormGrid itemsLinha={4}>
                        <FormField myWidth={30}>
                            <Label>CEP</Label>
                            <Input
                                type="text"
                                name="sd41cep"
                                value={formData.sd41cep}
                                onChange={handleChange}
                            />
                        </FormField>
                        <FormField>
                            <Label>Endereço</Label>
                            <Input
                                type="text"
                                name="sd41endereco"
                                value={formData.sd41endereco}
                                onChange={handleChange}
                            />
                        </FormField>
                        <FormField myWidth={30}>
                            <Label>Número</Label>
                            <Input
                                type="text"
                                name="sd41numero"
                                value={formData.sd41numero?.toString()}
                                onChange={handleChange}
                            />
                        </FormField>
                        <FormField>
                            <Label>Complemento</Label>
                            <Input
                                type="text"
                                name="sd41complemento"
                                value={formData.sd41complemento}
                                onChange={handleChange}
                            />
                        </FormField>
                    </FormGrid>
                    <FormGrid itemsLinha={4}>
                        <FormField>
                            <Label>Bairro</Label>
                            <Input
                                type="text"
                                name="sd41bairro"
                                value={formData.sd41bairro}
                                onChange={handleChange}
                            />
                        </FormField>
                        <FormField>
                            <Label>Municipio</Label>
                            <Input
                                type="text"
                                name="sd41municipio"
                                value={formData.sd41municipio}
                                onChange={handleChange}
                            />
                        </FormField>
                        <FormField myWidth={20}>
                            <Label>UF</Label>
                            <Input
                                type="text"
                                name="sd41uf"
                                value={formData.sd41uf}
                                onChange={handleChange}
                            />
                        </FormField>
                        <FormField>
                            <Label>Email</Label>
                            <Input
                                type="text"
                                name="sd41email"
                                value={formData.sd41email}
                                onChange={handleChange}
                            />
                        </FormField>
                    </FormGrid>
                    <FormGrid itemsLinha={7}>
                        <FormField>
                            <Label>CNPJ</Label>
                            <Input
                                type="text"
                                name="sd41cnpj"
                                value={formData.sd41cnpj}
                                onChange={handleChange}
                                required
                            />
                        </FormField>
                        <FormField myWidth={30}>
                            <Label>DDD</Label>
                            <Input
                                type="text"
                                name="sd41ddd1"
                                value={formData.sd41ddd1}
                                onChange={handleChange}
                                required
                            />
                        </FormField>
                        <FormField>
                            <Label>Telefone</Label>
                            <Input
                                type="text"
                                name="sd41fone1"
                                value={formData.sd41fone1}
                                onChange={handleChange}
                                required
                            />
                        </FormField>
                        <FormField myWidth={30}>
                            <Label>DDD</Label>
                            <Input
                                type="text"
                                name="sd41ddd2"
                                value={formData.sd41ddd2}
                                onChange={handleChange}
                            />
                        </FormField>
                        <FormField>
                            <Label>Celular 1</Label>
                            <Input
                                type="text"
                                name="sd41fone2"
                                value={formData.sd41fone2}
                                onChange={handleChange}
                            />
                        </FormField>
                        <FormField myWidth={30}>
                            <Label>DDD</Label>
                            <Input
                                type="text"
                                name="sd41ddd3"
                                value={formData.sd41ddd3}
                                onChange={handleChange}
                            />
                        </FormField>
                        <FormField>
                            <Label>Celular 2</Label>
                            <Input
                                type="text"
                                name="sd41fone3"
                                value={formData.sd41fone3}
                                onChange={handleChange}
                            />
                        </FormField>
                    </FormGrid>
                    <FormGrid>
                        <InputData
                            name="sd41dtinicio"
                            initialValue={formData.sd41dtinicio}
                            label="Inicio"
                            onChange={handleChangeDataInicio}
                        />
                        <FormField>
                            <Label>Diretório de Fórmulas</Label>
                            <Input
                                type="text"
                                name="sd41dirformulas"
                                value={formData.sd41dirformulas}
                                onChange={handleChange}
                                disabled={id != null}
                            />
                        </FormField>
                        <FormField>
                            <Label>Senha para Upload de Fórmulas</Label>
                            <Input
                                type="text"
                                name="sd41senha"
                                value={formData.sd41senha}
                                onChange={handleChange}
                            />
                            *Deixe em branco para manter a senha antiga
                        </FormField>
                    </FormGrid>

                    <ButtonContainer>
                        <ButtonSecundary type="button" onClick={handleCancelar}>
                            Cancelar
                        </ButtonSecundary>
                        <ButtonPrimary type="submit">
                            Salvar
                        </ButtonPrimary>
                    </ButtonContainer>
                </form>
            </FormContainer>
        </AppLayout>
    )
}

